import Controller from "./addItem.controller";
import template from "./addItem.html";

const addItem = {
  template,
  controller: Controller,
  bindings: {
    options: "<",
    model: "<",
    eventName: "<",
    title: "@",
    addItemHiddenFields: "<",
    addItemCustomizeOptions: "<",
  },
};

export default addItem;



// WEBPACK FOOTER //
// ./src/components/addItem/addItem.component.js